export default "__VITE_ASSET__672ab131__"